<!-- Card Header Start-->

<div class="lg:ps-6 pt-4 lg:pb-2.5 ps-4 pe-6 pb-1">
  <div class="flex justify-end">
    <button class="size-5 rounded-md flex justify-center items-center outline-0 hover:bg-black cursor-pointer group"
            [mat-dialog-close]="true" (click)="cancel()" matTooltip="Close">

      <!-- Gray cross (default) -->
      <img src="../../../../../../assets/images/icons/global/popup-cross.svg" class="block group-hover:hidden"
           alt="gray cross" height="10" width="10">

      <!-- White cross (on hover) -->
      <img src="../../../../../../assets/images/icons/global/popup-cross-white.svg" class="hidden group-hover:block"
           alt="white cross" height="10" width="10">
    </button>
  </div>
  <div class="lg:pe-6 pe-4 lg:mb-5 mb-2">
    <h1 class="font-medium text-[18px] leading-6 text-[#15191E] ">Schedule Recurring Ticket</h1>
    <p class="text-sm font-normal text-[#60646C] lg:mt-3 mt-1">Set tickets to recur weekly, monthly, or yearly</p>

  </div>


    <div
      class="flex items-center justify-center gap-2 bg-[#54578E12] p-[3px] rounded-md font-medium text-sm leading-4 text-[#6B7080]">
      <a href="javascript:void(0)" (click)="setTab('Weekly')" [ngClass]="activeClass ('Weekly')"
         class="border px-3 py-1.5 flex-1 text-center rounded">
        <span>Weekly</span>
      </a>
      <a href="javascript:void(0)" (click)="setTab('Monthly')" [ngClass]="activeClass ('Monthly')"
         class="border px-3 py-1.5 flex-1 text-center rounded">
        <span>Monthly</span>
      </a>
      <a href="javascript:void(0)" (click)="setTab('Yearly')" [ngClass]="activeClass ('Yearly')"
         class="border px-3 py-1.5 flex-1 text-center rounded">
        <span>Yearly</span>
      </a>
    </div>


</div>
<!-- Card Header End-->
<form *ngIf="form"  [formGroup]="form">
<div class="mat-typography !pt-2.5 lg:!pb-6 lg:!px-6 !pb-4 !px-4">

  <div class="grid grid-cols-2 gap-[14px]">

    <div class="col-span-2" *ngIf="activeTab === 'Monthly'">
      <label class="field-label required" for="onThe">On The</label>
      <ng-select formControlName="dayOfMonth" class="border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none min-h-[38px]"
       id="recurrenceMonthly" placeholder = "Select"
                        (change)="onSelectionChange()" [clearable]="false">
                          <ng-option *ngFor="let option of monthOptions"
                          [value]="option.value">
                            {{ option.label }}
                          </ng-option>
                        </ng-select>
    </div>

    <div class="col-span-2" *ngIf="activeTab === 'Weekly'">
      <label class="field-label required" for="on">On</label>
      <ul
        class="flex items-center justify-center gap-1 p-[5px] rounded-md font-medium text-xs text-[#6B7080] border border-[#E3E6EE] min-h-[38px]">
        <li *ngFor="let day of weekDays" class="flex-1">
          <button type="button" class="border lg:px-3 px-1.5 py-1 text-center rounded w-full cursor-pointer"
            (click)="toggleWorkingDay(day)" [ngClass]="{
              'bg-[#141414] text-white': isSelected(day),
              'bg-white border-[#E3E6EE]': !isSelected(day)
            }">
            {{ day | slice: 0:3 }}
          </button>
        </li>
      </ul>

    </div>

    <div class="col-span-2" [hidden]="activeTab !== 'Yearly'">
      <label class="field-label required" for="onThe2">On The</label>
      <div class="relative left_0">
        <input type="text" formControlName="dayOfYear" ngxDaterangepickerMd="picker" [singleDatePicker]="true"
               placeholder="Recursion Date" (change)="onDateChange()" readonly class="calendar-input font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE] rounded px-4 py-3 cursor-pointer bg-white w-full
            bg-no-repeat bg-[length:16px] bg-[position:right_10px_center] min-h-[38px] max-h-[38px]" [locale]="dateLocale" />
      </div>
    </div>

    <div class="col-span-1">
      <label class="field-label required" for="startDate">Start Date</label>
      <div class="relative left_0 bottom_0">
        <input type="text" ngxDaterangepickerMd [singleDatePicker]="true"
               placeholder="Start Date" formControlName="ticketScheduleStartDate" readonly class="calendar-input font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE] rounded px-4 py-3 cursor-pointer bg-white w-full
            bg-no-repeat bg-[length:16px] bg-[position:right_10px_center]" (change)="onChangeDate()" [locale]="dateLocale" />
      </div>
    </div>
    <div class="col-span-1">
      <label class="field-label required" for="endDate">End Date</label>
      <div class="relative left_0 bottom_0">
        <input type="text" ngxDaterangepickerMd [singleDatePicker]="true"
               placeholder="End Date" formControlName="ticketScheduleEndDate" readonly class="calendar-input font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE] rounded px-4 py-3 cursor-pointer bg-white w-full
            bg-no-repeat bg-[length:16px] bg-[position:right_10px_center]" (change)="onChangeDate()" [locale]="dateLocale" />
      </div>
    </div>

    <div class="col-span-1">
      <label class="field-label required" for="at">Start Time</label>
      <input type="time" class="input-field w-full" formControlName="scheduleTime" name="time-field">
    </div>

    <div class="col-span-1">
      <label class="field-label required" for="to">End Time</label>
      <input type="time" class="input-field w-full" formControlName="scheduleTimeTo" name="time-to-field">
    </div>


    <div class="col-span-1">
      <label class="field-label required" for="every">Every</label>
      <ng-select class="border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none"
      id="recurrence" formControlName="interval" [(ngModel)]="selectedOptionEvery"
                          (change)="onSelectionChangeEvery()" [clearable]="false">
                            <ng-option *ngFor="let option of weekOptions"
                            [value]="option.value">
                              {{ option.label }}
                            </ng-option>
                          </ng-select>
    </div>


    <div class="col-span-1">
      <label class="field-label required" for="scheduleStatus">Schedule Status</label>
      <ng-select formControlName="ticketScheduleStatusId" class="border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none"
       id="scheduledStatus" placeholder = "Select"
                        (change)="onSelectionChange()" [clearable]="false">
                          <ng-option *ngFor="let option of scheduleStatus"
                          [value]="option.id">
                            {{ option.name }}
                          </ng-option>
                        </ng-select>
    </div>

    <div class="col-span-1">
      <label class="field-label required" for="scheduleNotification">Schedule Notification</label>
      <ng-select formControlName="ticketScheduleNotificationStatusId" class="border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none"
       id="scheduleNotification" placeholder = "Select"
                        (change)="onSelectionChange()" [clearable]="false">
                          <ng-option *ngFor="let option of scheduleNotificationStatus"
                          [value]="option.id">
                            {{ option.name }}
                          </ng-option>
                        </ng-select>
    </div>

  </div>

</div>

<mat-dialog-actions class="lg:!p-6 !p-4 !border-t-[#E3E6EE]">
  <div class="flex-1">
    <bk-button 
        variant="primary"
        label="Schedule Ticket"
        size="sm"
        [loading]="loading" 
        buttonClass="text-white bg-[#141414] w-full !py-[5px] rounded-md" 
        (clicked)="onSubmit()" 
        [disabled]="this.form.invalid || isSaveButtonDisable">
    </bk-button>
  </div>
</mat-dialog-actions>
</form>

